import styled from 'styled-components';

export const NextTrackButtonWrapper = styled.div`
  display: flex;
  padding: 8px 12px;

  :hover {
    cursor: pointer;
  }

  &.isDisabled:hover {
    cursor: not-allowed;
  }

  path {
    fill: none;
    stroke: ${({ theme }) => theme.nextTrackButtonColor};
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 2px;
    fill-rule: evenodd;
    transition:
      fill 0.2s ease,
      stroke 0.2s ease;
  }

  &:not(.isDisabled):hover path {
    stroke: ${({ theme }) => theme.nextTrackButtonHoverColor};
  }
`;
